/**
 * recordOriginalAck — fire-and-forget POST that stamps the originality
 * acknowledgement on a freshly-uploaded content document (across every
 * `uploaded_content`, audiobook_series/chapter, cinematic series/episode
 * collection — backend tries all of them).
 *
 * Designed to be called immediately after any upload endpoint returns
 * a fresh `content_id` / `series_id` / `chapter_id` / `episode_id`. The
 * call is best-effort: if the backend rejects or the network drops, the
 * upload is NOT rolled back — the originality gate already lives in the
 * frontend checkbox.
 */
import { authFetch } from './authUtils';
import { ORIGINAL_ACK_VERSION } from '../components/OriginalContentAck';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const recordOriginalAck = async (contentId, opts = {}) => {
  if (!contentId) return { ok: false, skipped: 'missing-content-id' };
  try {
    const r = await authFetch(`${BACKEND_URL}/api/uploads/original-ack`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content_id: contentId,
        version: opts.version || ORIGINAL_ACK_VERSION,
        agreed: true,
      }),
    });
    if (!r.ok) return { ok: false, status: r.status };
    return await r.json();
  } catch (e) {
    return { ok: false, error: e?.message };
  }
};
